import { Button } from "~/react/ui/button"
import { Icon } from "~/react/ui/icon"
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuAction,
} from "~/react/ui/dropdown-menu"
import { cn } from "~/lib/utils"

type Action = {
  label: string;
  onClick?: () => void;
  variant?: "default" | "danger" | "secondary";
  disabled?: boolean;
};

type ActionsCellProps = {
  primaryAction?: Action;
  moreActions?: Action[];
  moreActionsAriaLabel?: string;
};

export function ActionsCell({
  primaryAction,
  moreActions = [],
  moreActionsAriaLabel = "More actions",
}: ActionsCellProps) {
  if (!primaryAction && moreActions.length === 0) {
    return null;
  }

  return (
    <div className="d-flex align-items-center gap-1">
      {primaryAction && (
        <Button
          variant={primaryAction.variant || "default"}
          size="xs"
          type="button"
          onClick={primaryAction.onClick}
        >
          {primaryAction.label}
        </Button>
      )}

      {moreActions.length > 0 && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="default"
              size="xs"
              iconOnly
              type="button"
              aria-label={moreActionsAriaLabel}
            >
              <Icon icon="ellipsis-h" size="sm" aria-hidden="true" />
            </Button>
          </DropdownMenuTrigger>

          <DropdownMenuContent className="dropdown-menu-end dropdown-menu--fixed">
            {moreActions.map((action, index) => (
              <DropdownMenuItem key={index}>
                <DropdownMenuAction
                  className={cn(
                    action.variant === "danger" && "dropdown-menu__action--danger"
                  )}
                  type="button"
                  onClick={action.onClick}
                  disabled={action.disabled}
                >
                  {action.label}
                </DropdownMenuAction>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
}
